import {
  SkeletonPage,
  Layout,
  Card,
  BlockStack,
  SkeletonDisplayText,
  SkeletonBodyText,
} from "@shopify/polaris";
import DataTableSkeleton from "components/datatable/DataTableSkeleton";

/**
 * Loading placeholder for the About Company page. Mirrors the real two-column
 * layout — the company users list on the left, the company details card on the
 * right — so the page doesn't show a blank screen while the company loads.
 */
export default function CompanyAboutSkeleton() {
  return (
    <SkeletonPage fullWidth>
      <Layout>
        <Layout.Section>
          <BlockStack gap="500">
            {/* company users list */}
            <Card roundedAbove="sm">
              <BlockStack gap="300">
                <SkeletonDisplayText size="small" />
                <DataTableSkeleton rows={8} columns={4} />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.Section>
        <Layout.Section variant="oneThird">
          <BlockStack gap="500">
            {/* company details */}
            <Card roundedAbove="sm">
              <BlockStack gap="300">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={6} />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
}
